import { render, staticRenderFns } from "./BlocksList.vue?vue&type=template&id=0cb250c7&scoped=true&lang=pug&"
import script from "./BlocksList.vue?vue&type=script&lang=js&"
export * from "./BlocksList.vue?vue&type=script&lang=js&"
import style0 from "./BlocksList.vue?vue&type=style&index=0&id=0cb250c7&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cb250c7",
  null
  
)

export default component.exports